var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass: "lpu-promotion-card d-flex flex-column ga-4 py-6",
      attrs: { "data-qa": "lpu_promotions_card" },
    },
    [
      _c("div", { staticClass: "d-flex flex-column ga-3" }, [
        _c(
          "h3",
          {
            staticClass: "text--text text-break ma-0",
            class: _setup.isMobile ? "text-subtitle-1" : "text-h6",
          },
          [
            _setup.canEdit && _setup.editHref
              ? [
                  _setup.statusPrefix
                    ? _c("span", [_vm._v(_vm._s(_setup.statusPrefix))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "lpu-promotion-card__edit",
                      attrs: { href: _setup.editHref },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_setup.title) + "\n        "
                      ),
                    ]
                  ),
                ]
              : [_vm._v("\n        " + _vm._s(_setup.title) + "\n      ")],
            _vm._v(" "),
            _setup.adminHref
              ? _c(
                  "a",
                  {
                    staticClass: "adminka ml-2",
                    attrs: {
                      href: _setup.adminHref,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v("\n        A\n      ")]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _setup.remainingLabel || _setup.dateRangeLabel
          ? _c("div", { staticClass: "d-flex justify-space-between" }, [
              _setup.remainingLabel
                ? _c(
                    "span",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.remainingLabel) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.dateRangeLabel
                ? _c(
                    "span",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.dateRangeLabel) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _setup.textHtml
        ? _c("div", {
            staticClass:
              "lpu-promotion-card__text bg-gray-40 rounded-20 text-body-1 text--text",
            class: _setup.isMobile ? "pa-4" : "pa-6",
            domProps: {
              innerHTML: _vm._s(
                _setup.textHtml /* eslint-disable-line vue/no-v-html */
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.starText
        ? _c(
            "p",
            {
              staticClass: "text-secondary--text ma-0",
              class: _setup.isMobile ? "text-body-2" : "text-body-1",
            },
            [_vm._v("\n    * - " + _vm._s(_setup.starText) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.formattedPhone
        ? _c(
            "div",
            {
              staticClass: "d-flex",
              class: _setup.isMobile ? "flex-column ga-3" : "align-center ga-6",
            },
            [
              _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.tStatic("Запись по телефону")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _setup.isMobile && _setup.rawPhoneHref
                ? _c(
                    "a",
                    {
                      staticClass:
                        "d-flex align-center ga-2 text-decoration-none text--text",
                      attrs: { href: _setup.rawPhoneHref },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-phone-call ui-icon-fz-smaller flex-shrink-0 text-lpu-branding-color-primary",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-body-1" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.formattedPhone) +
                            "\n      "
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "d-flex align-center ga-2 text--text" },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-phone-call ui-icon-fz-smaller flex-shrink-0 text-lpu-branding-color-primary",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-body-1" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.formattedPhone) +
                            "\n      "
                        ),
                      ]),
                    ]
                  ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }